import * as Yup from "yup";
import { ProductManufacturer } from "../Product/Product";

export interface Part {
  id?: string;
  partNumber: string;
  shortName: string;
  title: string;
  manufacturerId: string;
  description: string;
  tags?: any[];
  isEnabled: boolean;
  isDeleted: boolean;
  images?: PartImage[];
  dimension?: PartDimension;
  manufacturer?: ProductManufacturer;
}
export interface PartDimension {
  id?: string;
  partId?: string;
  weight?: number;
  weightUnit?: number;
  width?: number;
  widthUnit?: number;
  height?: number;
  heightUnit?: number;
  depth?: number;
  depthUnit?: number;
}
export interface PartImage {
  id?: string;
  url: string;
  sequence: number;
  partId?: string;
  title?: string;
  absoluteUrl?: string;
  description?: string;
}

export const PartInitialValues: Part = {
  title: "",
  partNumber: "",
  shortName: "",
  manufacturerId: "",
  description: "",
  isEnabled: true,
  isDeleted: false,
  dimension: {
    depth: 0,
    height: 0,
    weight: 0,
    width: 0,
    depthUnit: 1,
    heightUnit: 1,
    weightUnit: 0,
    widthUnit: 1,
  },
  tags: [],
};

export const PartValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is a required field"),
  partNumber: Yup.string().required("Part Number is a required field"),
  shortName: Yup.string().required("Short Name is a required field"),
  description: Yup.string().required("Description is a required field"),
  manufacturerId: Yup.string().required("Manufacturer is a required field"),
});

export const QuickPartValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is a required field"),
  partNumber: Yup.string().required("Part Number is a required field"),
  shortName: Yup.string().required("Short Name is a required field"),
  manufacturerId: Yup.string().required("Manufacturer is a required field"),
});

export const MassUnit = [
  {
    title: "Gram",
    value: 0,
  },
  {
    title: "Kilogram",
    value: 1,
  },
  {
    title: "Pound",
    value: 2,
  },
];

export const LenghtUnit = [
  {
    title: "Foot",
    value: 0,
  },
  {
    title: "Inch",
    value: 1,
  },
  {
    title: "Meter",
    value: 2,
  },
  {
    title: "Yard",
    value: 3,
  },
  {
    title: "Mile",
    value: 4,
  },
];
